// extracted by mini-css-extract-plugin
export default {"base":"PhoneMockupBodyLayout_base__7PE+u","base--body-centered":"PhoneMockupBodyLayout_base--body-centered__Ld11c","body":"PhoneMockupBodyLayout_body__GmK3b"};